import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 21.4l-15.962-9.216a2.967 2.967 0 00-2.998-.002 2.966 2.966 0 00-1.502 2.598v6.352L7.534 12.194a2.98 2.98 0 00-3-.002 2.978 2.978 0 00-1.5 2.6v18.41c0 1.086.562 2.058 1.5 2.6.472.27.986.406 1.5.406a2.98 2.98 0 001.5-.408l15.484-8.94v6.354c0 1.086.56 2.058 1.5 2.6.468.27.984.406 1.5.406a2.99 2.99 0 001.5-.408l15.96-9.216a2.964 2.964 0 001.502-2.594c0-1.086-.56-2.06-1.5-2.602z",
    clipRule: "evenodd"
  }))
};
export var FastForwardFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});